import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../hooks/use-is-mobile';
import { usePwaInstallPrompt } from '../hooks/use-pwa-install-prompt';
import { pwaInstallDismissedAtom } from '../stores/pwa.store';
import { BOTTOM_NAV_HEIGHT } from './navigation/BottomNav';

export function PwaInstallBanner() {
  const { t } = useTranslation('pwa');
  const { isInstallable, promptInstall, isDismissed } = usePwaInstallPrompt();
  const [, setDismissed] = useAtom(pwaInstallDismissedAtom);
  const isMobile = useIsMobile();

  if (!isInstallable || isDismissed) {
    return null;
  }

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        zIndex: 1200,
        borderRadius: 999,
        ...(isMobile
          ? {
              left: 12,
              right: 12,
              bottom: `calc(${BOTTOM_NAV_HEIGHT + 8}px + var(--safe-area-bottom))`,
            }
          : {
              right: 16,
              bottom: 16,
              maxWidth: 420,
            }),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          py: 0.75,
          pl: 1.5,
          pr: 0.75,
        }}
      >
        <GetAppIcon color="primary" sx={{ fontSize: 18, flexShrink: 0 }} />
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {t('installSubtitle')}
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={promptInstall}
          sx={{ borderRadius: 999, flexShrink: 0, py: 0.25 }}
        >
          {t('installButton')}
        </Button>
        <IconButton size="small" onClick={() => setDismissed(true)} aria-label="dismiss">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Paper>
  );
}
